<template>
  <v-container fluid>
    <fe-pruebas v-if="$store.state.emp.id_empresa == 193" />

    <fe-swisstex v-if="$store.state.emp.id_empresa == 49" />
    <fe-conab v-if="$store.state.emp.id_empresa == 55" />
    <fe-unique v-if="$store.state.emp.id_empresa == 50" />
    <fe-ib-marker v-if="$store.state.emp.id_empresa == 57" />
    <fe-txool v-if="$store.state.emp.id_empresa == 58" />
    <fe-personal-soft v-if="$store.state.emp.id_empresa == 69" />
    <fe-hygge-kidz v-if="$store.state.emp.id_empresa == 91" />
    <fe-panacom v-if="$store.state.emp.id_empresa == 111" />
    <fe-naka v-if="$store.state.emp.id_empresa == 96" />
    <fe-gy-c-group v-if="$store.state.emp.id_empresa == 115" />
    <fe-jadip v-if="$store.state.emp.id_empresa == 125" />
    <fe-veintinueve v-if="$store.state.emp.id_empresa == 128" />
    <fe-dlm v-if="$store.state.emp.id_empresa == 124" />
    <fe-erret v-if="$store.state.emp.id_empresa == 136" />
    <fe-diosa-textil v-if="$store.state.emp.id_empresa == 147" />
    <fe-abel v-if="$store.state.emp.id_empresa == 139" />
    <fe-astra v-if="$store.state.emp.id_empresa == 140" />
    <fe-estrategia v-if="$store.state.emp.id_empresa == 151" />
    <fe-suc-gomez v-if="$store.state.emp.id_empresa == 155" />
    <fe-vegeta v-if="$store.state.emp.id_empresa == 159" />
    <fe-serprore v-if="$store.state.emp.id_empresa == 152" />
    <fe-pno v-if="$store.state.emp.id_empresa == 119" />
    <fe-ratel v-if="$store.state.emp.id_empresa == 158" />
    <fe-consultoria v-if="$store.state.emp.id_empresa == 166" />
    <fe-ingredienta v-if="$store.state.emp.id_empresa == 175" />
    <fe-corporacion v-if="$store.state.emp.id_empresa == 180" />
    <fe-yeyi v-if="$store.state.emp.id_empresa == 181" />
    <fe-iotecsa v-if="$store.state.emp.id_empresa == 182" />
    <fe-ana v-if="$store.state.emp.id_empresa == 184" />
    <feteam v-if="$store.state.emp.id_empresa == 190" />
    <fe-libreria-solo v-if="$store.state.emp.id_empresa == 191" />
    <fe-francisco v-if="$store.state.emp.id_empresa == 200" />
    <fe-walter v-if="$store.state.emp.id_empresa == 213" />
    <fe-billy v-if="$store.state.emp.id_empresa == 214" />
    <fe-irma-guirola v-if="$store.state.emp.id_empresa == 216" />
    <fe-jose-angel-cruz v-if="$store.state.emp.id_empresa == 212" />
    <fe-euracio v-if="$store.state.emp.id_empresa == 222" />
    <fe-ideas-soluciones-tecnicas v-if="$store.state.emp.id_empresa == 231"></fe-ideas-soluciones-tecnicas>
    <fe-john-linares v-if="$store.state.emp.id_empresa == 239"></fe-john-linares>
    <fe-monte-contreras v-if="$store.state.emp.id_empresa == 243" />
    <fe-carlos-maximiliano v-if="$store.state.emp.id_empresa == 244" />
    <fe-carlos-nieto v-if="$store.state.emp.id_empresa == 246" />
    <fe-hersot v-if="$store.state.emp.id_empresa == 248" />
    <fe-william v-if="$store.state.emp.id_empresa == 250" />
    <fe-gino v-if="$store.state.emp.id_empresa == 252" />
    <div
      v-if="
        $store.state.emp.id_empresa != 193 && //PRUEBAS
        $store.state.emp.id_empresa != 49 &&
        $store.state.emp.id_empresa != 55 &&
        $store.state.emp.id_empresa != 50 &&
        $store.state.emp.id_empresa != 57 &&
        $store.state.emp.id_empresa != 58 &&
        $store.state.emp.id_empresa != 69 &&
        $store.state.emp.id_empresa != 91 &&
        $store.state.emp.id_empresa != 111 &&
        $store.state.emp.id_empresa != 119 &&
        $store.state.emp.id_empresa != 115 &&
        $store.state.emp.id_empresa != 125 &&
        $store.state.emp.id_empresa != 128 &&
        $store.state.emp.id_empresa != 124 &&
        $store.state.emp.id_empresa != 136 &&
        $store.state.emp.id_empresa != 147 &&
        $store.state.emp.id_empresa != 139 &&
        $store.state.emp.id_empresa != 140 &&
        $store.state.emp.id_empresa != 151 &&
        $store.state.emp.id_empresa != 155 &&
        $store.state.emp.id_empresa != 159 &&
        $store.state.emp.id_empresa != 152 &&
        $store.state.emp.id_empresa != 95 &&
        $store.state.emp.id_empresa != 158 &&
        $store.state.emp.id_empresa != 166 &&
        $store.state.emp.id_empresa != 175 &&
        $store.state.emp.id_empresa != 180 &&
        $store.state.emp.id_empresa != 181 &&
        $store.state.emp.id_empresa != 182 &&
        $store.state.emp.id_empresa != 184 &&
        $store.state.emp.id_empresa != 190 &&
        $store.state.emp.id_empresa != 191 &&
        $store.state.emp.id_empresa != 200 &&
        $store.state.emp.id_empresa != 96 &&
        $store.state.emp.id_empresa != 213 &&
        $store.state.emp.id_empresa != 214 &&
        $store.state.emp.id_empresa != 216 &&
        $store.state.emp.id_empresa != 212 &&
        $store.state.emp.id_empresa != 222 &&
        $store.state.emp.id_empresa != 231 &&
        $store.state.emp.id_empresa != 239 &&
        $store.state.emp.id_empresa != 243 &&
        $store.state.emp.id_empresa != 244 &&
        $store.state.emp.id_empresa != 246 &&
        $store.state.emp.id_empresa != 248 &&
        $store.state.emp.id_empresa != 250 &&
        $store.state.emp.id_empresa != 252
      "
    >
      <lottie
        :options="defaultOptions"
        :height="450"
        v-on:animCreated="handleAnimation"
      />
    </div>
  </v-container>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "../../animations/no_data.json";

import fePruebas from "../Facturacion/FePruebas.vue";

import feSwisstex from "../Facturacion/Swisstex/FeSwisstex.vue";
import feConab from "../Facturacion/Conab/FeConab.vue";
import feUnique from "../Facturacion/Unique/FeUnique.vue";
import feIbMarker from "../Facturacion/IBMaker/FeIBMarker.vue";
import feTxool from "./Txool/FeTxool.vue";
import fePersonalSoft from "./PersonalSoft/FePersonalSoft.vue";
import feHyggeKidz from "./HyggeKidz/FeHyggeKidz.vue";
import fePanacom from "../Facturacion/Panacom/Fepanacom.vue";
import feNaka from "../Facturacion/Naka/FeNaka.vue";
import feGyCGroup from "../Facturacion/GyCGroup/GyCGroup.vue";
import feJadip from "../Facturacion/Jadip/Fejadip.vue";
import feVeintinueve from "./Veintinueve/FEVeintinueve.vue";
import feDlm from "./Dlm/FeDlm.vue";
import feErret from "./Erret/FeErret.vue";
import feDiosaTextil from "./DiosaTextil/FeDiosaTextil.vue";
import feAbel from "./Abel/FeAbel.vue";
import feAstra from "./Astra/FeAstra.vue";
import feEstrategia from "./Estrategia/FeEstrategia.vue";
import feSucGomez from "./SucGomez/FeSucGomez.vue";
import feVegeta from "./Vegeta/FeVegeta.vue";
import feSerprore from "./Serprore/FeSerprore.vue";
import fePno from "./PNO/FePno.vue";
import feRatel from "./Ratel/FeRatel.vue";
import feConsultoria from "./Consultoria/FeConsultoria.vue";
import feIngredienta from "./Ingredienta/FeIngredienta.vue";
import feCorporacion from "./Corporacion/FeCorporacion.vue";
import feYeyi from "./Yeyi/FeYeyi.vue";
import feIotecsa from './Iotecsa/FeIotecsa.vue';
import feAna from "./Ana/FeAna.vue";
import feteam from "./Team/FeTeam.vue";
import feLibreriaSolo from "./LibreriaSolo/FELibreriaSolo.vue";
import feFrancisco from "./Francisco/FeFrancisco.vue";
import feWalter from "./Walter/FeWalter.vue";
import feBilly from "./Billy/FeBilly.vue";
import feIrmaGuirola from "./IrmaGuirola/FeIrmaGuirola.vue";
import feJoseAngelCruz from "./JoseAngelCruz/FeJoseAngeCruz.vue";
import feEuracio from "./Euracio/FeEuracio.vue";
import feIdeasSolucionesTecnicas from "./IdeasSolucionesTecnicas/FeIdeasSolucionesTecnicas.vue";
import FeJohnLinares from "./JohnLinares/FeJohnLinares.vue";
import FeMonteContreras from "./MonteContreras/FeMonteContreras.vue";
import FeCarlosMaximiliano from "./CarlosMaximiliano/FeCarlosMaximiliano.vue";
import FeCarlosNieto from "./CarlosNieto/FeCarlosNieto.vue";
import FeHersot from "./Hersot/FeHersot.vue";
import FeWilliam from "./William/FeWilliam.vue";
import FeGino from "./Gino/FeGino.vue";

export default {
  data: () => ({
    defaultOptions: { animationData: animationData },
    animationSpeed: 1,
  }),
  components: {
    Lottie,
    fePruebas,
    feSwisstex,
    feConab,
    feUnique,
    feIbMarker,
    feTxool,
    fePersonalSoft,
    feHyggeKidz,
    fePanacom,
    feNaka,
    feGyCGroup,
    feJadip,
    feVeintinueve,
    feDlm,
    feErret,
    feDiosaTextil,
    feAbel,
    feAstra,
    feEstrategia,
    feSucGomez,
    feVegeta,
    feSerprore,
    fePno,
    feRatel,
    feConsultoria,
    feIngredienta,
    feCorporacion,
    feYeyi,
    feIotecsa,
    feAna,
    feteam,
    feLibreriaSolo,
    feFrancisco,
    feWalter,
    feBilly,
    feIrmaGuirola,
    feJoseAngelCruz,
    feEuracio,
    feIdeasSolucionesTecnicas,
    FeJohnLinares,
    FeMonteContreras,
    FeCarlosMaximiliano,
    FeCarlosNieto,
    FeHersot,
    FeWilliam,
    FeGino
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
  },
};
</script>